import { Layout } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";

export class DemoInputDialog extends Layout {
    getDemoPath() {
        return ["Dialogs", "Input"];
    }

    buttonShowSnackbarOnClicked() {
        CommonDialogs.showInputDialog("Enter a value").then(response => {
            CommonDialogs.showMessage("You entered " + response);
        });
    }
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoInputDialog", [ "Dialogs", "Input" ]));
